import { PROGRAM_CONFIG } from './constants';

// TODO (MW) Consider setting this into application state (redux)
const Program = (): any => {
  let internalValue: ProgramDTO | undefined;

  return {
    set: (program: ProgramDTO | string): void => {
      if (program === undefined) internalValue = program;
      if (typeof program === 'string') {
        const programLookup = PROGRAM_CONFIG[program.toLowerCase()]
          ? program.toLowerCase()
          : Object.keys(PROGRAM_CONFIG).find(
              (p) => PROGRAM_CONFIG[p].name === program,
            );
        internalValue = {
          name: programLookup || program,
          label:
            programLookup !== undefined
              ? PROGRAM_CONFIG[programLookup]?.name
              : program,
          id: '',
        };
      } else {
        internalValue = program;
      }
    },
    get: (): ProgramDTO | undefined => {
      return internalValue;
    },
    clear: (): void => {
      internalValue = undefined;
    },
  };
};

export default Program();
